import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/TextPage.css';

const TelegramLinkPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { isAuth, isLoading, showNotification } = useAuth();
    const [isProcessing, setIsProcessing] = useState(false);
    const [linkResult, setLinkResult] = useState(null);

    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setLinkResult({
                success: false,
                message: 'Отсутствует токен привязки'
            });
            return;
        }

        // Ждем завершения загрузки авторизации
        if (isLoading) {
            return;
        }

        if (!isAuth) {
            showNotification('Войдите в аккаунт для привязки Telegram', 'error');
            navigate('/');
            return;
        }

        // Автоматически выполняем привязку при загрузке страницы
        handleTelegramLink();
    }, [token, isAuth, isLoading]);

    const handleTelegramLink = async () => {
        if (isProcessing) return;

        setIsProcessing(true);

        try {
            const response = await fetch(`/api/telegram/link/${token}`, {
                method: 'POST',
                credentials: 'include'
            });

            const data = await response.json();

            setLinkResult(data);

            if (data.success) {
                showNotification(data.message, 'success');
                // Перенаправляем в профиль через 3 секунды
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            } else {
                showNotification(data.message, 'error');
            }

        } catch (error) {
            console.error('Ошибка привязки Telegram:', error);
            const errorResult = {
                success: false,
                message: 'Произошла ошибка при привязке аккаунта'
            };
            setLinkResult(errorResult);
            showNotification(errorResult.message, 'error');
        } finally {
            setIsProcessing(false);
        }
    };

    if (!token) {
        return (
            <div className="text-page">
                <div className="text-page-container">
                    <h1>❌ Ошибка привязки</h1>
                    <p>Отсутствует токен привязки. Попробуйте создать новую ссылку в Telegram боте.</p>
                    <button
                        className="btn sign-up"
                        onClick={() => navigate('/')}
                    >
                        Вернуться на главную
                    </button>
                </div>
            </div>
        );
    }

    // Показываем загрузочный экран, пока проверяется авторизация
    if (isLoading) {
        return (
            <div className="text-page">
                <div className="text-page-container">
                    <h1>🔄 Загрузка</h1>
                    <p>Проверяем авторизацию...</p>
                    <div className="loading-spinner" style={{ textAlign: 'center', margin: '20px 0' }}>
                        ⏳
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="text-page">
            <div className="text-page-container">
                {isProcessing ? (
                    <>
                        <h1>🔄 Привязка аккаунта</h1>
                        <p>Обрабатываем привязку вашего Telegram аккаунта...</p>
                        <div className="loading-spinner" style={{ textAlign: 'center', margin: '20px 0' }}>
                            ⏳
                        </div>
                    </>
                ) : linkResult ? (
                    linkResult.success ? (
                        <>
                            <h1>🎉 Успешная привязка!</h1>
                            <p>{linkResult.message}</p>
                            <div style={{
                                background: '#1a4d3a',
                                border: '1px solid #2d5a47',
                                borderRadius: '8px',
                                padding: '20px',
                                margin: '20px 0',
                                textAlign: 'center'
                            }}>
                                <h3 style={{ color: '#4ade80', margin: '0 0 10px 0' }}>
                                    🎁 Бонус за привязку
                                </h3>
                                <p style={{ color: '#86efac', margin: 0 }}>
                                    Вы получили <strong>50 фриспинов</strong>!
                                </p>
                            </div>
                            <p>Вы будете перенаправлены на главную страницу через несколько секунд...</p>
                            <button
                                className="btn sign-up"
                                onClick={() => navigate('/')}
                            >
                                Перейти на главную
                            </button>
                        </>
                    ) : (
                        <>
                            <h1>❌ Ошибка привязки</h1>
                            <p>{linkResult.message}</p>
                            <button
                                className="btn sign-up"
                                onClick={() => navigate('/')}
                            >
                                Вернуться на главную
                            </button>
                        </>
                    )
                ) : (
                    <>
                        <h1>🔗 Привязка Telegram</h1>
                        <p>Подготавливаем привязку аккаунта...</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default TelegramLinkPage;
